<!-- // 管理员认证 -->
<template>
  <div>
    <div class="contentList">
      <template v-for="(val, idx) in 1">
        <div style="padding: 0 5%; margin: 0.3rem auto 0.2rem" :key="idx">
          <el-row :gutter="50">
            <el-col :span="14">
              <el-form ref="form" :disabled="!isEdit" label-width="1rem">
                <el-form-item label="学校名称:">
                  <el-input v-model="userData.name"></el-input>
                </el-form-item>
                <el-form-item label="所在地区:">
                  <el-cascader
                    :options="options"
                    v-model="schoolProvince"
                    @change="handleChange"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="街道地址:">
                  <el-input v-model="userData.schoolAddress"></el-input>
                </el-form-item>
                <el-form-item label="联系电话:">
                  <el-input v-model="userData.schoolPhone"></el-input>
                </el-form-item>
                <el-form-item label="校友人数:">
                  <el-input
                    v-model="userData.xyCount"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="个人管理员:">
                  <div class="names">
                    <span v-for="(v, i) in userData.glY_XY" :key="i">{{
                      v.name
                    }}</span>
                  </div>
                </el-form-item>
                <el-form-item label="教职工管理员:">
                  <div class="names">
                    <span v-for="(v, i) in userData.glY_JZG" :key="i">{{
                      v.name
                    }}</span>
                  </div>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="10">
              <el-form ref="form" :disabled="!isEdit" label-width="80px">
                <el-form-item label="校徽:">
                  <!-- <el-row :gutter="0">
                    <el-col :span="11">
                      <img
                        class="headerImg"
                        :src="apiUrl + userData.logo"
                        alt=""
                      />
                     
                    </el-col>
                  </el-row> -->
                  <el-upload
                    class="upload-demo"
                    :on-change="fileChange"
                    :on-preview="handlePreview"
                    :on-success="uploadSuccess"
                    :on-remove="handleRemove"
                    :action="uploadConfig.uploadurl"
                    :headers="uploadConfig.uploadHeaders"
                    :file-list="uploadConfig.fileList"
                    accept=".jpg,.png"
                    list-type="picture"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">
                      只能上传jpg/png文件，且不超过500kb
                    </div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {
  provinceAndCityDataPlus,
  TextToCode,
  CodeToText,
} from "element-china-area-data";

export default {
  props: {
    currSchoolInfo: {},
    isEdit: {
      default: false,
    },
  },
  //watch监听方法
  watch: {
    //深度监听（解决了值刷新不及时的问题）
    currSchoolInfo: {
      immediate: true,
      handler: function (newval, oldVal) {
        this.userData = newval;
        this.init();
        this.getAddress(this.userData.schoolProvince, this.userData.schoolCity);
      },
    },
  },
  data() {
    return {
      apiUrl: "",
      //省市联级
      options: provinceAndCityDataPlus,
      list_ZloHYvTf: [0, 0, 0],
      userData: {},
      address: ["", ""],
      schoolProvince: [],
      //文件上传信息
      uploadConfig: {
        //文件上传
        uploadurl: "",
        //文件列表
        fileList: [],
        uploadHeaders: {
          Authorization: localStorage.getItem("token"),
        },
      },
    };
  },
  created() {
    this.apiUrl = `${window.api.apiurl}`;
    this.uploadConfig.uploadurl = `${window.api.apiurl}/api/Common/UploadFile`;
    this.userData = this.currSchoolInfo;
    this.init();
    this.getAddress(this.userData.schoolProvince, this.userData.schoolCity);
  },

  beforeDestroy() {
    this.uploadConfig.fileList = [];
  },

  methods: {
    getAddress(value1, value2) {
      this.schoolProvince = TextToCode[value1][value2].code;
      console.log(this.schoolProvince);
    },
    init() {
      this.uploadConfig.fileList = [];
      this.uploadConfig.fileList.push({
        url: `${window.api.apiurl}${this.userData.logo}`,
      });
    },
    handleChange(value) {
      console.log(value);
      var dz = [];
      if (value[1] != null) {
        dz.push(CodeToText[value[0]]);
        if (CodeToText[value[1]] == "全部") dz.push("");
        else dz.push(CodeToText[value[1]]);
      } else {
        if (CodeToText[value[0]] == "全部") dz.push("");
        else dz.push(CodeToText[value[0]]);
      }
      this.address = dz;
      console.log(this.address);
    },
    //编辑学校
    editSchool() {
      var _this = this;
      if (this.$dataConver.isNull(this.userData.name)) {
        this.$message.error("请输入学校名称！");
        return false;
      }
      if (
        this.$dataConver.isNull(this.address[0]) &&
        this.$dataConver.isNull(this.userData.schoolProvince)
      ) {
        this.$message.error("请选择学校所在省份！");
        return false;
      }
      if (
        this.$dataConver.isNull(this.address[1]) &&
        this.$dataConver.isNull(this.userData.schoolCity)
      ) {
        this.$message.error("请选择学校所在城市！");
        return false;
      }
      if (this.$dataConver.isNull(this.userData.schoolAddress)) {
        this.$message.error("请输入学校街道地址！");
        return false;
      }
      if (this.$dataConver.isNull(this.userData.schoolPhone)) {
        this.$message.error("请输入学校联系电话！");
        return false;
      }
      if (
        /^1[34578]\d{9}$/.test(this.userData.schoolPhone) == false &&
        /([0-9]{3,4}-)?[0-9]{7,8}/.test(this.userData.schoolPhone) == false
      ) {
        this.$message.error("请输入正确的联系电话！");
        return false;
      }
      if (this.$dataConver.isNull(this.userData.logo)) {
        this.$message.error("请上传学校校徽！");
        return false;
      }
      this.$api
        .post("/admin/School/EditSchool", {
          id: this.userData.id,
          name: this.userData.name,
          logo: this.userData.logo,
          schoolProvince:
            this.address[0] == ""
              ? this.userData.schoolProvince
              : this.address[0],
          schoolCity:
            this.address[1] == "" ? this.userData.schoolCity : this.address[1],
          schoolAddress: this.userData.schoolAddress,
          schoolPhone: this.userData.schoolPhone,
          alumnCount: "string",
          creationTime: "2022-07-27T09:01:47.621Z",
          isDeleted: false,
        })
        .then((res) => {
          if (res.succeed) {
            this.$message.success("操作成功！");
            this.address = [];
            _this.$parent.$parent.closeDetials();
            _this.$parent.$parent.getSchoolList();
          } else {
            this.$message.error(res.error);
          }
        });
    },
    //文件改变钩子函数
    fileChange(file, fileList) {
      // 这是关键一句
      if (fileList.length > 0) {
        this.uploadConfig.fileList = [fileList[fileList.length - 1]];
      }
    },
    //已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },
    //文件上传成功
    uploadSuccess(file, fileList) {
      console.log(file.data);
      console.log(fileList);
      console.log(this.uploadConfig.fileList);
      this.userData.logo = file.data;
    },
    //移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      console.log(this.uploadConfig.fileList);
      this.userData.logo = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.contentList {
  img.headerImg {
    border: 1px solid #dedede;
    width: 1rem;
    height: 1rem;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 50%;
  }
  .names {
    span {
      min-width: 0.6rem;
      white-space: nowrap;
      display: inline-block;
    }
  }
  .el-cascader {
    width: 100%;
  }
  .el-upload-list__item {
    transition: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userDetail/shool.vue